module.exports = __webpack_public_path__ + "media/images/DrivuQScreenshot-23d2723e43b42a808476eed38d36c651.png";